import { hotWorks } from "@/mocks/manga";

const statusTone: Record<string, string> = {
  已补全: "bg-accent-100 text-accent-700",
  绝版修复: "bg-primary-100 text-primary-700",
  连载中: "bg-secondary-100 text-secondary-800",
  考古更新: "bg-secondary-100 text-secondary-800",
};

export default function HotWorks() {
  return (
    <section id="hot" className="bg-background-100 py-12 md:py-16">
      <div className="mx-auto max-w-6xl px-4 md:px-6">
        <div className="mb-8 flex flex-col gap-2">
          <p className="text-xs font-semibold tracking-widest text-primary-600">CLASSIC ARCHIVE</p>
          <div className="flex flex-wrap items-end justify-between gap-3">
            <div>
              <h2 className="font-heading text-2xl text-foreground-950 md:text-3xl">热门经典老番 · 人气补档</h2>
              <p className="mt-2 max-w-xl text-sm text-foreground-600">
                编辑部近期修复与整理得最多、最受怀旧漫爱好者欢迎的经典老番。
              </p>
            </div>
            <span className="text-sm text-foreground-600">按热度排序 · 持续更新</span>
          </div>
        </div>

        <div className="grid grid-cols-2 gap-4 md:grid-cols-3 lg:grid-cols-6">
          {hotWorks.map((work) => (
            <article
              key={work.id}
              className="group cursor-pointer overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-all duration-300 hover:-translate-y-1"
            >
              <div className="relative aspect-[3/4] overflow-hidden">
                <img
                  src={work.img}
                  alt={`${work.title}${work.era}经典老番漫画封面`}
                  className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <span
                  className={`absolute right-2 top-2 rounded-full px-2 py-0.5 text-[11px] font-semibold ${statusTone[work.status] ?? "bg-background-200 text-foreground-700"}`}
                >
                  {work.status}
                </span>
              </div>
              <div className="p-3">
                <h3 className="truncate font-heading text-sm text-foreground-950">{work.title}</h3>
                <p className="mt-1 truncate text-xs text-foreground-600">
                  {work.author} · {work.year}
                </p>
                <div className="mt-2 flex items-center justify-between">
                  <span className="rounded-full bg-secondary-100 px-2 py-0.5 text-[11px] text-secondary-800">
                    {work.genre}
                  </span>
                  <span className="text-[11px] text-foreground-500">{work.era}</span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}